import { action } from "@storybook/addon-actions";
import { ComponentMeta, Story as GenericStory } from "@storybook/react";
import isChromatic from "chromatic/isChromatic";
import React from "react";
import { MemoryRouter } from "react-router-dom";
import { noop } from "../../utils";
import Multiselect from "../form/Multiselect/Multiselect";
import Filters from "./Filters";

const group = "options";
const mockOptions = [
    { label: "one", value: 1, group },
    { label: "two", value: 2, group },
    { label: "three", value: 3, group },
    { label: "four", value: 4, group },
    { label: "five", value: 5, group }
];

const commonArgs: React.ComponentProps<typeof Filters> = {
    title: "Filters",
    filters: [
        [
            {
                title: "Using multi-select with custom renderer",
                name: "multiselct",
                render: () => (
                    <Multiselect
                        options={mockOptions}
                        optionGroups={[group]}
                        trackName="Stories.Multiselect.TrackEvent"
                        noResults="No results"
                        onChange={noop}
                    />
                )
            },
            { type: "divider", title: "Hidden Divider", hidden: true },
            {
                title: "Hidden Status Filter",
                hidden: true,
                name: "status",
                options: [
                    {
                        value: "in_progress",
                        label: "In progress"
                    },
                    {
                        value: "done",
                        label: "Done"
                    }
                ],
                trackEventName: "Status"
            },
            { type: "divider", title: "Hidden Divider", hidden: true },
            [
                [
                    {
                        title: "Status",
                        name: "status",
                        options: [
                            {
                                value: "in_progress",
                                label: "In progress"
                            },
                            {
                                value: "done",
                                label: "Done"
                            }
                        ],
                        trackEventName: "Status"
                    },
                    {
                        title: "Some type",
                        name: "type",
                        options: ["Type 1", "Type 2"],
                        trackEventName: "SomeType"
                    }
                ],
                {
                    title: "Multiselect status",
                    name: "multiselect_status[]",
                    options: [
                        {
                            value: "open",
                            label: "Open"
                        },
                        {
                            value: "in_progress",
                            label: "In progress"
                        },
                        {
                            value: "done",
                            label: "Done"
                        }
                    ],
                    multiSelect: true,
                    trackEventName: "MultiselectStatus"
                }
            ],
            { type: "divider" },
            [
                {
                    title: "Some type after divider",
                    name: "type_2",
                    options: ["Type 1", "Type 2", "Type 3"],
                    multiSelect: true,
                    trackEventName: "SomeTypeAfterDivider"
                },
                {
                    title: "Another type after divider",
                    name: "type_2_2",
                    options: ["Type 1", "Type 2"],
                    trackEventName: "AnotherTypeAfterDivider"
                },
                { type: "divider" },
                {
                    title: "Some type after vertical divider",
                    name: "type_2_3",
                    options: ["Type 1", "Type 2", "Type 3"],
                    multiSelect: true,
                    trackEventName: "SomeTypeAfterVerticalDivider"
                }
            ],
            { type: "divider", title: "Divider Title" },
            [
                {
                    title: "Some type after titled divider",
                    name: "type_3",
                    options: ["Type 1", "Type 2", "Type 3"],
                    multiSelect: true,
                    trackEventName: "SomeTypeAfterTitledDivider"
                },

                { type: "divider", title: "Vertical Divider" },
                {
                    title: "Some type after titled vertical divider",
                    name: "type_3_3",
                    options: ["Type 1", "Type 2", "Type 3"],
                    multiSelect: true,
                    trackEventName: "SomeTypeAfterTitledVerticalDivider"
                }
            ]
        ]
    ],
    onClose: action("clicked"),
    trackClearFiltersEventName: "ClearAll",
    trackCloseEventName: "Close",
    disableAnimation: isChromatic()
};

export default {
    title: "common/Filters",
    component: Filters,
    args: commonArgs,
    parameters: {
        chromatic: { delay: 2000, pauseAnimationAtEnd: true }
    }
} as ComponentMeta<typeof Filters>;

type Story = GenericStory<React.ComponentProps<typeof Filters>>;

export const Default: Story = args => {
    return (
        <MemoryRouter>
            <Filters {...args} />
        </MemoryRouter>
    );
};
